import { render, staticRenderFns } from "./_tab_.vue?vue&type=template&id=d9962214&scoped=true&"
import script from "./_tab_.vue?vue&type=script&lang=js&"
export * from "./_tab_.vue?vue&type=script&lang=js&"
import style0 from "./_tab_.vue?vue&type=style&index=0&id=d9962214&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9962214",
  null
  
)

export default component.exports